export const convertToPounds = (weightInKg?: number | string) => {
  return weightInKg != null ? Math.round(Number(weightInKg) * 2.2046) : 0;
};
